import { TbPackageOff } from "react-icons/tb";

const NoDataView = ({
                        title = "No Data Found",
                        icon: Icon = TbPackageOff,
                        className = "",
                    }) => {
    return (
        <div
            className={`text-center text-backgroundColor py-10 my-5 ${className}`}
        >
            <Icon className="mx-auto w-40 h-40 mb-5 text-backgroundColor animate-pulse" />

            <h3 className="text-lg font-semibold mb-2 mt-5">
                {title}
            </h3>
        </div>
    );
};

export default NoDataView;